<ix-fieldset [title]="'OAuth Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="client_id"
    [label]="'OAuth Client ID' | translate"
    [required]="true"
    [tooltip]="oauthTooltip"
  ></ix-input>

  <ix-input
    formControlName="client_secret"
    type="password"
    [label]="'OAuth Client Secret' | translate"
    [required]="true"
    [tooltip]="oauthTooltip"
  ></ix-input>
</ix-fieldset>

<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="token"
    type="password"
    [label]="'Token' | translate"
    [required]="true"
    [tooltip]="tokenTooltip"
  ></ix-input>
</ix-fieldset>

